<template>
	<span class="label-box">
		<span class="label-box__value">
			<slot></slot>
		</span>
	</span>
</template>

<script>
export default {
	name: 'LabelBox'
}
</script>

<style scoped lang="scss">
.label-box {
	display: inline-flex;
	align-items: center;
	padding: 0 4px;
	border-radius: 3px;
	background-color: #b9003c;
	color: #ffffff;
	height: 20px;
}

.label-box__value {
	font-size: 11px;
}
</style>
